import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthPage from './pages/AuthPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import TuteeDashboard from './pages/TuteeDashboard';
import AdminDashboard from './pages/AdminDashboard';
import TutorDashboard from './pages/TutorDashboard';
import TutorProfileEdit from './pages/TutorProfileEdit';
import Discover from './pages/Discover';
import Support from './pages/Support'; 
import AddSubjects from './pages/AddSubjects';
import SubjectPortal from './pages/SubjectPortal';
import TutorRequest from './pages/TutorRequests';
import TuteePrivateRequests from './pages/TuteePrivateRequests';
import RequestPortal from './pages/RequestPortal';
import ProfileView from './pages/ProfileView';
import TuteeSubscriptions from './pages/TuteeSubscriptions';
import TutorWallet from './pages/TutorWallet';
import PaymentModal from './pages/Paymentmodal';
import PaymentResult from './pages/Paymentresults';
import IdeaOfKaddle from './pages/IdeaOfKaddle';
import TutorPublicProfile from './pages/ProfileView'; // ← added: public slug-based profile page
import Terms from './pages/Terms';

// Simple auth check
const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

// Protected Route
const ProtectedRoute = ({ children, requiredRole }) => {
  const isAuth = isAuthenticated();
  const user = getCurrentUser();

  if (!isAuth) return <Navigate to="/auth" replace />;

  if (requiredRole && user?.role !== requiredRole) {
    return <Navigate to="/auth" replace />;
  }

  return children;
};

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/auth" replace />} />
      <Route path="/idea" element={<IdeaOfKaddle />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/Terms" element={<Terms />} />
      <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

      <Route path="/dashboard/support" element={<Support />} />

      {/* PAYMENT ROUTES */}
      <Route path="/payment/success" element={<PaymentResult type="success" />} />
      <Route path="/payment/cancel" element={<PaymentResult type="cancel" />} />
      <Route path="/payment/error" element={<PaymentResult type="error" />} />

      <Route
        path="/tutee/dashboard"
        element={
          <ProtectedRoute requiredRole="tutee">
            <TuteeDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/tutee/Requests"
        element={
          <ProtectedRoute requiredRole="tutee">
            <TuteePrivateRequests />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute requiredRole="admin">
            <AdminDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/tutor/dashboard"
        element={
          <ProtectedRoute requiredRole="tutor">
            <TutorDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/tutor/tutorReq"
        element={
          <ProtectedRoute requiredRole="tutor">
            <TutorRequest />
          </ProtectedRoute>
        }
      />

      <Route
        path="/tutor/profile/edit"
        element={
          <ProtectedRoute requiredRole="tutor">
            <TutorProfileEdit />
          </ProtectedRoute>
        }
      />


      <Route
        path="/tutee/dashboard/Discover"
        element={
          <ProtectedRoute requiredRole="tutee">
            <Discover />
          </ProtectedRoute>
        }
      />

      <Route
        path="/TeachingCentre/AddSubjects"
        element={
          <ProtectedRoute requiredRole="tutor">
            <AddSubjects />
          </ProtectedRoute>
        }
      />

      <Route
        path="/tutor/:id"
        element={
          <ProtectedRoute requiredRole="tutee">
            <ProfileView />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/dashboard/subscriptions"
        element={
          <ProtectedRoute requiredRole="tutee">
            <TuteeSubscriptions />
          </ProtectedRoute>
        }
      />

      <Route
  path="/payment/checkout"
  element={
    <ProtectedRoute requiredRole="tutee">
      <PaymentModal />
    </ProtectedRoute>
  }
/>
      
      <Route
        path="/dashboard/TutorWallet"
        element={
          <ProtectedRoute requiredRole="tutor">
            <TutorWallet />
          </ProtectedRoute>
        }
      />

      <Route path="/portal/:subjectId" element={<SubjectPortal />} />

      <Route path="/request-portal/:subjectId" element={<RequestPortal />} />

      {/* PUBLIC TUTOR PROFILE — e.g. mykaddle.com/NathanHolmer
          Not wrapped in ProtectedRoute: this is meant to be shared
          and viewed outside the app, by logged-out visitors too.
          Must stay LAST among real routes (but before the catch-all)
          since it's a single dynamic segment and would otherwise be
          too greedy if it matched before more specific paths. Static
          routes above always win regardless of order in React Router
          v6's ranked matching, but keeping it last here is clearer to
          read and safer if that ranking behavior ever changes. */}
      <Route path="/:slug" element={<TutorPublicProfile />} />

      {/* ALWAYS LAST */}
      <Route path="*" element={<Navigate to="/auth" replace />} />
    </Routes>
  );
}

export default App;